import { message, notification } from "antd";
import classnames from "classnames";
import React, { useEffect, useState } from "react";

import { ICommentItemProps } from "../types";
import { fetchCommentLike } from "../../../services/article";
import StorageData from "../../../utils/localstorage";
import WriteComment from "../WriteComment";
import styles from "./index.module.less";
import Like from "../Like";
import { replaceUrlWithAnchor } from "@Lib/common";

const localStorageKey = "articleLikeComments";

const CommentItem: React.FC<ICommentItemProps> = (props: ICommentItemProps) => {
  const { response, data, id: contentId, isSign, type } = props;

  const { comment, user } = data;
  const { likes, content, date, id: commentId, reply } = comment;
  const { mid, name, cover, label } = user;

  const [isReplyComment, setIsReplyComment] = useState(false);
  const [likeCount, setLikeCount] = useState<number>(likes);
  const [likeStatus, setLikeStatus] = useState<boolean>(false);
  let storageData = new StorageData(localStorageKey);

  const openSignWindow = () => {
    notification.error({ message: "對不起，您尚未登入！" });
    return;
    const el = document.getElementById("iframe-base-sigin");
    if (el) {
      el.style.display = "block";
    }
  };
  const isReply = (res?: any) => {
    // if (!isSign) {
    //   openSignWindow();
    //   return;
    // }
    setIsReplyComment(!isReplyComment);
    if (res && res.status === 12000) {
      response?.();
    }
  };

  const getId = () => {
    return `${contentId}_${commentId}_${mid}`;
  };

  // 獲取存儲數據
  const getStorageData = () => {
    try {
      let data = storageData.getData(localStorageKey);

      if (!data) {
        return undefined;
      }
      if (Array.isArray(data)) {
        return storageData.arrayToMap(data);
      }
    } catch (err) {
      console.log(err);
    }
    return undefined;
  };

  // 更新點讚
  const setLocalLikeStatus = (id: number, count: number) => {
    let nextData = getStorageData();
    if (!nextData) {
      nextData = new Map();
    }
    if (Object.prototype.toString.call(nextData) === "[object Map]") {
      (nextData as Map<string, number>).set(getId(), count);

      storageData.setData(localStorageKey, nextData);
    }
  };

  // 检查有沒有點過讚
  const isLiked = () => {
    return getStorageData()?.has(getId());
  };

  // 點讚
  const handleClickLikeBtn = async (id: string, nextLikeStatus: boolean) => {
    if (isLiked()) {
      message.error("請不要重複操作哦");
      return;
    }
    const result = (await fetchCommentLike({ id, type, otherId: contentId })) as any;
    if (result?.status === 12000) {
      setLikeCount(Number(likeCount) + 1);
      setLikeStatus(nextLikeStatus);
      setLocalLikeStatus(Number(id), Number(likeCount) + 1);
    }
  };

  useEffect(() => {
    // 獲取點讚狀態
    if (isLiked()) {
      setLikeStatus(true);
    }
  }, []);

  let isTextarea = classnames({
    "textarea-show-item": isReplyComment,
    "textarea-item": !isReplyComment,
  });

  return (
    <section className={styles["IframeCommentItem"]}>
      <div className={styles["avatar"]}>
        <img src={cover} alt='' />
      </div>
      <div className={styles["message"]}>
        <div className='text-16 text-[#333] flex font-[600] items-center'>
          {name}
          {!!label && (
            <div className='bg-[#85ABFF] text-white text-14 ml-8 rounded-4 px-4 h-20 flex items-center font-[400]'>
              <img className='w-14 h-14 mr-2' src='https://photo.8891.com.tw/2024/08/29/1724924350594421.png' alt='' />
              {label}
            </div>
          )}
          <time className='text-[#999] ml-16 text-12 font-[400] pt-4'>{date}</time>
        </div>
        <div className={styles["comment-content"]} dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(content) }} />
        {typeof reply === "object" && reply.comment && (
          <div className={styles["reply-comment"]}>
            <div className={styles["reply-name"]}>{reply.user.name}</div>
            <div className={styles["reply-content"]} dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(reply.comment.content) }} />
          </div>
        )}
        <div className={styles["footer"]}>
          <div className={styles["replay-comment-btn"]} onClick={() => isReply()}>
            {isReplyComment ? "收起" : "回覆"}
          </div>
          <Like likeCount={likeCount} likeStatus={likeStatus} id={String(commentId)} onClickLike={handleClickLikeBtn} />
          <div className={styles[isTextarea]}>
            <WriteComment
              size='small'
              type={type}
              id={contentId}
              re_id={commentId}
              re_mid={mid}
              isSign={isSign}
              response={(res) => isReply(res)}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommentItem;
